//Here we define some function to general filter content, that are later used in WebUI.
//The idea is to have a map, mapping a name to a special function that applies a specific filter.
//Later on we can use the function name in WebUI configurations. etc.

import isWeekday from "../date/isWeekday";
import simpleFormat from "../date/simpleFormat";

/**
 * A filter function that return only the dates that are within predefined interval.
 * @param {array} dates - Array of dates to be filtered.
 * @param {object} options - Filtering options.
 * @return {array} - All the dates gte options.start and lte options.end.
 */
export function datesOutOfRange(dates = [], options = {}) {
    if (!options.start && !options.end) {
        return Array.from(dates);
    }
    const start = options.start ? simpleFormat(options.start) : null;
    const end = options.end ? simpleFormat(options.end) : null;
    return dates.filter(date => {
        const workDate = simpleFormat(date);
        const satisfyStart = !(start && workDate < start);

        const satisfyEnd = !(end && workDate > end);
        return satisfyStart && satisfyEnd;
    });
}

/**
 * A filter function that return only the dates that are not weekends.
 * @param {array} dates - Array of dates to be filtered.
 * @return {array} - All the dates gte options.start and lte options.end.
 */
export function weekendDates(dates = []) {
    //Note that WebUI will pass options parameter to every filter function, in this case we don't need it.
    return dates.filter(date => {
        return isWeekday(date);
    });
}
